import React from 'react';


import { formatCurrency, sortByDate } from "../../utils/commonutils";


const getHeaderRow = (contractType, type) => {
    return <tr>
        <th>
            <div>
                Date of service
                <i className={`sort amount icon ml-05`}></i>
            </div>
        </th>
        <th>
            <div>
                Practice
                <i className={`sort  icon ml-05`}></i>
            </div>
        </th>
        <th>
            <div>
                Patient#
                <i className={`sort amount  icon ml-05`}></i>
            </div>
        </th>
        {type !== 'HYNbillableCare' && <th>
            <div>
                Age
                <i className={`sort amount  icon ml-05`}></i>
            </div>
        </th>}
        {type === 'HYNbillableCare' && <th>
            <div>
                Provider
                <i className={`sort amount  icon ml-05`}></i>
            </div>
        </th>}
        {type === 'HYNbillableCare' && <th>
            <div>
                Treating Provider
                <i className={`sort amount  icon ml-05`}></i>
            </div>
        </th>}
        {type !== 'HYNbillableCare' && <th>
            <div>
                Insurance
                <i className={`sort amount  icon ml-05`}></i>
            </div>
        </th>}
        <th>
            <div>
                Proc Code
                <i className={`sort amount  icon ml-05`}></i>
            </div>
        </th>
        {type !== 'HYNbillableCare' && <th>
            <div>
                Next Appointment
                <i className={`sort amount  icon ml-05`}></i>
            </div>
        </th>}
        <th>
            <div>
                bCare
                <i className={`sort amount  icon ml-05`}></i>
            </div>
        </th>
        {type == 'HYNbillableCare' && <th>
            <div>
                Pay/HYN
                <i className={`sort amount  icon ml-05`}></i>
            </div>
        </th>}
        {(contractType === 'GOX' || contractType === 'GOZ') &&
            <th>
                <div>
                    X-deductions
                    <i className={`sort amount  icon ml-05`}></i>
                </div>
            </th>
        }

    </tr>
}


const generateTableRows = (details, getPracticeName, type) => {
    let totalBcare = 0;
    let totalXdeductions = 0;
    let list = {};
    let totalBcareHyn = 0;
    const data = (type === 'HYNbillableCare') ? details.hynBCareData : details.billableCareData;
    const contractType = details.contractType;
    const dataSorted = sortByDate(data, 'ProcDate');
    if (contractType === 'GOX' || contractType === 'GOZ') {
        details.goxList.forEach((xlist) => {
            list[xlist.dateOfService + xlist.practice + xlist.patientId + xlist.procCode] = xlist;
        })
    }
    const tableRows = dataSorted.map(iRow => {
        const key = iRow.ProcDate + iRow.Practice + iRow.PatNum + iRow.ProcCode;
        totalBcare += (iRow.bCare ?? iRow.price ?? 0);
        totalBcareHyn += iRow['pay/HYN'];
        totalXdeductions += (list[key]?.bCare ?? list[key]?.price ?? 0);
        return <tr key={key}>
            <td>{iRow.ProcDate}</td>
            <td>{getPracticeName(iRow.Practice)}</td>
            <td>{iRow.PatNum}</td>
            {type !== 'HYNbillableCare' && <td>{iRow.Age}</td>}
            {type === 'HYNbillableCare' && <td>{iRow.Provider}</td>}
            {type === 'HYNbillableCare' && <td>{details.providerAbbr}</td>}
            {type !== 'HYNbillableCare' && <td>{iRow.CarrierName}</td>}
            <td>{iRow.ProcCode}</td>
            {type !== 'HYNbillableCare' && <td>{iRow.Next_Apt}</td>}
            <td>{formatCurrency(iRow.bCare ?? iRow.price)}</td>
            {type === 'HYNbillableCare' && <td>{formatCurrency(iRow['pay/HYN'])}</td>}
            {(contractType === 'GOX' || contractType === 'GOZ') && <td>{formatCurrency(list[key]?.bCare ?? list[key]?.price)}</td>}
        </tr>
    })

    let totalRows = [<tr>
        <td colSpan={type === 'HYNbillableCare' ? "6" : "7"}><b>Total</b></td>
        <td><b>{formatCurrency(totalBcare)}</b></td>
        {type === 'HYNbillableCare' && <td><b>{formatCurrency(totalBcareHyn)}</b></td>}
        {(contractType === 'GOX' || contractType === 'GOZ') && <td><b>{formatCurrency(totalXdeductions)}</b></td>}
    </tr>]

    return tableRows.concat(totalRows);
}

function BillableCareTable(props) {
    const { details, getPracticeName, type } = props;

    return (
        <table className="table table-striped fixed compact table-hover my-0 TableHeaderFixed tablePopUp">
            <thead>
                {getHeaderRow(details.contractType, type)}
            </thead>
            <tbody>
                {generateTableRows(details, getPracticeName, type)}
            </tbody>
        </table>
    )
}

export default BillableCareTable;